export function homeworkSelectors(state) {
  return state.homework;
}